import profile from './profile.js';
import accounts from './accounts.js';
import accounts$1 from './legal.js';

function customer(backendAxiosInstance) {
  return {
    ...profile(backendAxiosInstance),
    ...accounts(backendAxiosInstance),
    ...accounts$1(backendAxiosInstance)
  };
}

export { customer as default };
//# sourceMappingURL=index.js.map
